import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "./Dropdown";
import UpdateButtons from "./UpdateButtons";
import DatePicker from "./DatePicker";
// import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { actionCreators } from "../redux/sagas/marketing";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

// TODO: place css from attendance
const { updateFilters } = actionCreators;
const DateFilters = ({ moduleName }) => {
  const dispatch = useDispatch();

  const {
    availableFilters,
    filters: {
      referralCategories,
      referralValues,
      rangeValue,
      rangeOptions,
      filtersDirty,
      // compareDates,
      periodType,
      periodTypes
      // compareType,
      // compareTypes
    }
  } = useSelector((state) => state[moduleName]);

  return (
    <div id="override-edit-selection-bar" className="edit-selections-bar">
      <div className="top-filter">
        <div>
          {availableFilters.includes("compare_dates") && (
            <div className="select-box-no-width">
              {/*<p>Compare Dates</p>*/}
              {/*<ToggleableButton*/}
              {/*  isRadio*/}
              {/*  isActive={compareDates}*/}
              {/*  title={moduleName + "-compare-dates"}*/}
              {/*  onClick={(toggleValue) =>*/}
              {/*    dispatch(updateFilters({ moduleName, compareDates: toggleValue }))*/}
              {/*  }*/}
              {/*/>*/}
            </div>
          )}

          {availableFilters.includes("referral_categories") && (
            <div className="select-box-no-width">
              <p>Referral Categories</p>
              <MultiSelectDropdown
                height="350px"
                filterType="Locations"
                enableDefaultSelected
                numberDisplayed={1}
                enableOnly
                includeSelectAll
                selectedFilters={referralValues}
                options={referralCategories}
                updateLocations={(newValues) =>
                  dispatch(updateFilters({ moduleName, referralValues: newValues }))
                }
              />
            </div>
          )}
        </div>
        <div className="top-filter__right">
          {availableFilters.includes("period") && (
            <Dropdown
              title="Period Type"
              options={periodTypes}
              value={periodType?.capitalize()}
              onChange={(newValue) =>
                newValue !== periodType?.capitalize() &&
                dispatch(updateFilters({ moduleName, periodType: newValue }))
              }
            />
          )}
          {availableFilters.includes("date_range") && (
            <Dropdown
              title="Date Range"
              classNames="date-range-select-box"
              options={rangeOptions}
              value={rangeValue}
              onChange={(newValue) => {
                const { startDate, endDate } = newValue;
                newValue?.id !== rangeValue?.id &&
                  dispatch(
                    updateFilters({
                      moduleName,
                      startDate,
                      endDate,
                      rangeValue: newValue
                    })
                  );
              }}
            />
          )}

          {availableFilters.includes("date") && (
            <DatePicker
              moduleName={moduleName}
              monthly={availableFilters.includes("monthly_picker")}
            />
          )}

          {/*{compareDates && (*/}
          {/*  <Dropdown*/}
          {/*    vcCompare*/}
          {/*    title="Compare Period"*/}
          {/*    classNames="compare-period-select-box"*/}
          {/*    value={compareType}*/}
          {/*    options={compareTypes}*/}
          {/*    onChange={(newCompareType) =>*/}
          {/*      newCompareType.id !== compareType.id &&*/}
          {/*      dispatch(updateFilters({ moduleName, compareType: newCompareType }))*/}
          {/*    }*/}
          {/*  />*/}
          {/*)}*/}

          {/* Update and Reset Buttons */}
          {filtersDirty && <UpdateButtons moduleName={moduleName} />}
        </div>
      </div>
    </div>
  );
};

DateFilters.propTypes = { moduleName: PropTypes.string };

export default DateFilters;
